import '@formatjs/intl-relativetimeformat/locale-data/fa.js';
import '@formatjs/intl-relativetimeformat/locale-data/ar.js';
import '@formatjs/intl-relativetimeformat/locale-data/en.js';
const locales = {
    en: {
        id: 'en',
        default: true,
        path: '',
        direction: 'ltr',
        title: 'English',
        emoji: '🇬🇧',
        formatOptions: {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            calendar: 'gregory'
        },
        dateFormat: 'DD/MM/YYYY',
        regions: [
            `en-US`,
            'en_GB'
        ]
    }
};
export { locales };
